module.exports = __webpack_public_path__ + "static/santaquincity-39b72da8bcefb15bc3f483782b49805c.jpg";